import React from 'react';

import americanMassageTherapyAssociationLogo from '../../assests/amta-logo.png';

export function AmericanMassageTherapyAssociationLogo({ style }){
  return (
    <img 
      src={americanMassageTherapyAssociationLogo} 
      alt="American Massage Therapy Association logo"
      style={style} 
    />
  );
}